import moment from "moment";
import _ from "lodash";
import searchLogo from "../assets/images/searchLogo.svg";
import { validateRate, validateTermDate } from "./tradeValidations";
import { dtcStatusColors, status } from "./constants";
import { rateFormatter } from "./commonFunctions";
function is_number(char: any) {
  return !isNaN(parseInt(char));
}
var myValueFormatter = (p: any) => {
  let is_n = is_number(p.value);
  if (is_n) {
    return formatNumber.format(p.value);
  }
};

const markFormatter = (p: any) => {
  if (p?.value && !isNaN(p?.value) && _.isString(p.value)) {
    return parseInt(p.value);
  }
  else if (_.isNumber(p?.value)) {
    return p?.value;
  }
  return "";
}

function validateMark(markValue: any) {
  let mark = parseInt(markValue);
  if (mark && mark > 95 && mark < 106) {
    return true;
  }
  return false;
}

const formatNumber = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 2,
});

var myValueFormatter_quantity = (p: any) => {
 const value = _.isString(p?.value) && p?.value?.includes(",")?(p?.value?.replace(/,/g, "")):p?.value
 let is_n = is_number(value);
  if (is_n) {
    return formatNumber_q.format(value);
  }
};

const formatNumber_q = new Intl.NumberFormat("en-US", {
  maximumFractionDigits: 2,
});

export const ColumnDefs = [
  {
    headerName: "",
    field: "select",
    floatingFilter: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    headerCheckboxSelection: true,
    checkboxSelection: true,
    editable: false,
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "0.5px solid #E1E1E1",
    },
    pinned: "left",
    lockPinned: true,
    cellClass: "lock-pinned",

    minWidth: 70,
    maxWidth: 90,
    suppressSizeToFit: false,
  },
  {
    headerName: "UI Trade Id",
    field: "uiTradeId",
    // hide: true,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "0.5px solid #E1E1E1",
    },
    minWidth: 95,
    maxWidth: 120,
    suppressSizeToFit: false,
  },
  {
    headerName: "B/L",
    field: "b_l",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: function (params: any) {
      if (
        params.node.data.status === "Booked" ||
        params.node.data.status === "Sent" ||
        params.node.data.status === "Settled"
      ) {
        return false;
      } else {
        return true;
      }
    },
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      let bNLVal = params.node.data.b_l;
      bNLVal =
        bNLVal == undefined || bNLVal == null ? "" : bNLVal.toUpperCase();
      if (
        params.node.data.isTotalRow == undefined &&
        !(bNLVal == "B" || bNLVal == "L")
      ) {
        return {
          display: "flex",
          alignItems: "center",
          backgroundColor: status.error,
        };
      } else {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #E1E1E1",
        };
      }
    },
    minWidth: 60,
    maxWidth: 70,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Cpty Id",
    field: "cpty_id",
    floatingFilter: false,
    filter: "agTextColumnFilter",
    valueFormatter: function (params: any) {
      if (
        params != undefined &&
        params.data != undefined &&
        params.data != null &&
        params.data.cpty_id != null
      ) {
        try {
          return params.data.cpty_id.toUpperCase();
        } catch (e) { }
      }
    },
    editable: function (params: any) {
      if (
        params.node.data.status === "Booked" ||
        params.node.data.status === "Sent" ||
        params.node.data.status === "Settled"
      ) {
        return false;
      } else {
        return true;
      }
    },
    tooltipField: "cpty_id",
    tooltipComponentParams: function (params: any) {
      if (
        params.node.data.cpty_id === undefined ||
        params.node.data.cpty_id === ""
      ) {
        return { message: "Invalid Cpty ID" };
      }
    },
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      if (
        params.node.data.isTotalRow == undefined &&
        (params.node.data.cpty_id === undefined ||
          params.node.data.cpty_id === "" ||
          params.node.data.cpty_id === null ||
          params.node.data.cpty_name === undefined ||
          params.node.data.cpty_name === "" ||
          params.node.data.cpty_name === null)
      ) {
        return {
          display: "flex",
          alignItems: "center",
          backgroundColor: status.error,
        };
      } else if (params.node.data.cpty_id === null) {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #E1E1E1",
        };
      } else {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #E1E1E1",
        };
      }
    },
    minWidth: 75,
    maxWidth: 80,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Cpty Name",
    field: "cpty_name",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    tooltipField: "cpty_name",
    tooltipComponentParams: function (params: any) {
      if (
        params.node.data.cpty_name === undefined ||
        params.node.data.cpty_name === "" ||
        params.node.data.cpty_name === null
      ) {
        return { message: "Invalid Cpty Name" };
      }
    },
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      if (
        params.node.data.cpty_name === undefined ||
        params.node.data.cpty_name === "" ||
        params.node.data.cpty_name === null
      ) {
        return {
          display: "flex",
          alignItems: "center",
          backgroundColor: status.error,
        };
      } else {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #E1E1E1",
        };
      }
    },
    minWidth: 170,
    maxWidth: 250,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Ticker",
    field: "tb_ticker",
    floatingFilter: false,
    valueFormatter: function (params: any) {
      if (
        params != undefined &&
        params.data != undefined &&
        params.data != null &&
        params.data.tb_ticker != null
      ) {
        try {
          return params.data.tb_ticker.toUpperCase();
        } catch (e) { }
      }
    },
    editable: function (params: any) {
      if (
        params.node.data.status === "Booked" ||
        params.node.data.status === "Sent" ||
        params.node.data.status === "Settled"
      ) {
        return false;
      } else {
        return true;
      }
    },
    tooltipField: "tb_ticker",
    tooltipComponentParams: function (params: any) {
      if (
        params.node.data.tb_ticker === undefined ||
        params.node.data.tb_ticker === ""
      ) {
        return { message: "Invalid Ticker" };
      }
    },
    filter: "agTextColumnFilter",
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      if (
        params.node.data.isTotalRow == undefined &&
        (params.node.data.tb_ticker === undefined ||
          params.node.data.tb_ticker === "" ||
          params.node.data.cusip === "" ||
          params.node.data.cusip === undefined ||
          params.node.data.cusip === null ||
          params.node.data.ticker_price === "" ||
          params.node.data.ticker_price === undefined ||
          params.node.data.ticker_price === null ||
          params.node.data.errorCode === "Invalid Ticker")
      ) {
        return {
          display: "flex",
          alignItems: "center",
          backgroundColor: status.error,
        };
      } else if (params.node.data.tb_ticker === null) {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #E1E1E1",
        };
      } else {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #E1E1E1",
        };
      }
    },
    minWidth: 100,
    width: 120,
    maxWidth: 180,
    suppressSizeToFit: false,
  },
  {
    headerName: "Mkt Price",
    field: "ticker_price",
    type: "rightAligned",
    floatingFilter: false,
    editable: false,
    filter: "agNumberColumnFilter",
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
    tooltipField: "ticker_price",
    valueFormatter: myValueFormatter,
    tooltipComponentParams: function (params: any) {
      if (
        params.node.data.ticker_price === "" ||
        params.node.data.ticker_price === undefined
      ) {
        return { message: "Invalid Mkt Price" };
      }
    },
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      if (
        params.node.data.isTotalRow == undefined &&
        (params.node.data.ticker_price === "" ||
          params.node.data.ticker_price === undefined ||
          params.node.data.ticker_price === null)
      ) {
        return {
          display: "flex",
          alignItems: "center",
          backgroundColor: status.error,
          justifyContent: "flex-end",
        };
      } else {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #E1E1E1",
          justifyContent: "flex-end",
        };
      }
    },
    minWidth: 100,
    maxWidth: 130,
    suppressSizeToFit: false,
  },
  {
    headerName: "Cusip",
    field: "cusip",
    floatingFilter: false,
    filter: "agTextColumnFilter",
    editable: function (params: any) {
      if (
        params.node.data.isTotalRow === undefined &&
        (params.node.data.status === "Booked" ||
          params.node.data.status === "Settled" ||
          params.node.data.status === "Sent")
      ) {
        return false;
      } else {
        return true;
      }
    },
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
    tooltipField: "cusip",
    tooltipComponentParams: function (params: any) {
      if (
        params.node.data.cusip === "" ||
        params.node.data.cusip === undefined
      ) {
        return { message: "Invalid Cusip" };
      }
    },
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      if (
        params.node.data.isTotalRow == undefined &&
        (params.node.data.cusip === "" ||
          params.node.data.cusip === undefined ||
          params.node.data.cusip === null)
      ) {
        return {
          display: "flex",
          alignItems: "center",
          backgroundColor: status.error,
        };
      } else {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #E1E1E1",
        };
      }
    },
    minWidth: 100,
    maxWidth: 180,
    suppressSizeToFit: false,
    filterParams: {
      allowedCharPattern: "\\d\\-\\,",
      numberParser: (text: any) => {
        return parseFloat(text.replace(",", ""));
      },
    },
  },
  {
    headerName: "Quantity",
    field: "quantity",
    type: "rightAligned",
    cellDataType:'text',
    floatingFilter: false,
    editable: function (params: any) {
      if (
        params.node.data.status === "Booked" ||
        params.node.data.status === "Sent" ||
        params.node.data.status === "Settled"
      ) {
        return false;
      } else {
        return true;
      }
    },
    filter: "agNumberColumnFilter",
    tooltipField: "quantity",
    tooltipComponentParams: function (params: any) {
      if (params.node.data.quantity > 999999999999) {
        return {
          message: "Invalid Quantity",
        };
      } else if (params.node.data.quantity < 0) {
        return {
          message: "Loan value should be bigger then 0",
        };
      }
    },

    valueFormatter: myValueFormatter_quantity,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      if (
        params.node.data.isTotalRow == undefined &&
        (!params.node.data.quantity ||
          isNaN(params.node.data.quantity) ||
          params.node.data.quantity <= 0 ||
          params.node.data.quantity % 1 !== 0 ||
          params.node.data.quantity > 999999999999)
      ) {
        return {
          display: "flex",
          alignItems: "center",
          backgroundColor: status.error,
          justifyContent: "flex-end",
        };
      } else {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #E1E1E1",
          justifyContent: "flex-end",
        };
      }
    },
    minWidth: 100,
    maxWidth: 150,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Rate",
    field: "rate",
    type: "rightAligned",
    floatingFilter: false,
    tooltipField: "rate",
    tooltipComponentParams: function (params: any) {
      if (
        params.node.data.rate < -999.9999 ||
        params.node.data.rate > 999.9999 ||
        params.node.data.rate === ""
      ) {
        return {
          message: "Invalid Rate",
        };
      }
    },
    editable: function (params: any) {
      if (
        params.node.data.status === "Booked" ||
        params.node.data.status === "Sent" ||
        params.node.data.status === "Settled"
      ) {
        return false;
      } else {
        return true;
      }
    },
    filter: "agNumberColumnFilter",
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      if (params.node.data.isTotalRow || validateRate(params.node.data.rate))
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #E1E1E1",
          justifyContent: "flex-end",
        };
      else
        return {
          display: "flex",
          alignItems: "center",
          backgroundColor: status.error,
          justifyContent: "flex-end",
        };
    },
    minWidth: 60,
    maxWidth: 100,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
     valueFormatter: rateFormatter
  },
  {
    headerName: "Mark",
    field: "mark",
    type: "rightAligned",
    floatingFilter: false,
    editable: false,
    filter: "agNumberColumnFilter",
    valueFormatter: markFormatter,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      if (!params.node.data.mark && !params.node.data.isTotalRow) {
        return {
          display: "flex",
          alignItems: "center",
          backgroundColor: status.error,
          justifyContent: "flex-end",
        };
      } else if (
        !validateMark(params.node.data.mark) &&
        !params.node.data.isTotalRow
      ) {
        return {
          display: "flex",
          alignItems: "center",
          backgroundColor: status.warning,
          justifyContent: "flex-end",
        };
      } else {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #E1E1E1",
          justifyContent: "flex-end",
        };
      }
    },
    minWidth: 70,
    maxWidth: 100,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Value",
    field: "value",
    type: "rightAligned",
    editable: function (params: any) {
      if (
        params.node.data.status === "Booked" ||
        params.node.data.status === "Sent" ||
        params.node.data.status === "Settled"
      ) {
        return false;
      } else {
        return true;
      }
    },
    valueFormatter: myValueFormatter,
    floatingFilter: false,
    filter: "agNumberColumnFilter",
    floatingFilterComponentParams: { suppressFilterButton: true },
    tooltipField: "value",
    tooltipComponentParams: function (params: any) {
      if (params.node.data.value > 250000000) {
        return {
          message: "Value > 250M",
        };
      } else if (params.node.data.value < 0) {
        return {
          message: "Value > 0",
        };
      } else if (
        params.node.data.value === undefined ||
        params.node.data.value === ""
      ) {
        return {
          message: "Invalid Contract Value",
        };
      }
    },
    cellStyle: function (params: any) {
      if (
        params.node.data.isTotalRow == undefined &&
        (!params.node.data.value ||
          params.node.data.value > 999999999999.99 ||
          params.node.data.value <= 0 ||
          params.node.data.errorCode === "Invalid Ticker" ||
          params.node.data.errorCode === "Invalid CPTY")
      ) {
        return {
          display: "flex",
          alignItems: "center",
          backgroundColor: status.error,
          justifyContent: "flex-end",
        };
      } else if (((params.node.data?.errorCode?.length>0 || params.node.data?.rejected_error_reasons?.length>0) && (params.node.data?.errorCode === "Credit Limit Exceeded" || params.node.data?.rejected_error_reasons === "Credit Limit Exceeded"  || params.node.data?.isCreditLimitExceeded)) || params.node.data.value >= 250000000) {
        return {
          display: "flex",
          alignItems: "center",
          backgroundColor: status.warning,
          justifyContent: "flex-end",
        };
      } else {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #E1E1E1",
          justifyContent: "flex-end",
        };
      }
    },
    minWidth: 120,
    maxWidth: 220,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "C/N",
    field: "c_n",
    floatingFilter: false,
    editable: function (params: any) {
      if (
        params.node.data.status === "Booked" ||
        params.node.data.status === "Sent" ||
        params.node.data.status === "Settled"
      ) {
        return false;
      } else {
        return true;
      }
    },
    filter: "agTextColumnFilter",
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      if (params.node.data.c_n && !/[CBN]/.test(params.node.data.c_n)) {
        return {
          display: "flex",
          alignItems: "center",
          backgroundColor: status.error,
          justifyContent: "flex-end",
        };
      } else {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #E1E1E1",
          justifyContent: "flex-end",
        };
      }
    },
    minWidth: 60,
    maxWidth: 80,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Div",
    field: "div",
    floatingFilter: false,
    type: "rightAligned",
    editable: function (params: any) {
      if (
        params.node.data.status === "Booked" ||
        params.node.data.status === "Sent" ||
        params.node.data.status === "Settled"
      ) {
        return false;
      } else {
        return true;
      }
    },
    filter: "agNumberColumnFilter",
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "0.5px solid #E1E1E1",
      justifyContent: "flex-end",
    },
    minWidth: 80,
    maxWidth: 80,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "P/C",
    field: "profit_center",
    floatingFilter: false,
    editable: function (params: any) {
      if (
        params.node.data.status === "Booked" ||
        params.node.data.status === "Sent" ||
        params.node.data.status === "Settled"
      ) {
        return false;
      } else {
        return true;
      }
    },
    filter: "agTextColumnFilter",
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      if (
        params.node.data.profit_center &&
        (params.node.data.profit_center.length !== 1 ||
          !/[A-Z0-9 !@#$%&*()+=?]/gm.test(params.node.data.profit_center))
      ) {
        return {
          display: "flex",
          alignItems: "center",
          backgroundColor: status.error,
          justifyContent: "flex-end",
        };
      } else {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #E1E1E1",
          justifyContent: "flex-end",
        };
      }
    },
    minWidth: 60,
    maxWidth: 80,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Term Date",
    field: "term_date",
    floatingFilter: false,
    editable: function (params: any) {
      if (
        params.node.data.status === "Booked" ||
        params.node.data.status === "Sent" ||
        params.node.data.status === "Settled"
      ) {
        return false;
      } else {
        return true;
      }
    },
    floatingFilterComponentParams: { suppressFilterButton: true },

    tooltipField: "term_date",
    tooltipComponentParams: function (params: any) {
      let CurrentDate = new Date();
      let CurrentDateLength = moment(CurrentDate).format("MM/DD/YYYY");
      if (params.node.data.term_date < CurrentDateLength) {
        return { message: "Invalid Term Date" };
      }
    },
    cellStyle: function (params: any) {
      let todayDate = moment();
      let localTermDate = moment(params.node.data.term_date);

      if (
        params.node.data.term_date === "-" ||
        params.node.data.term_date === undefined ||
        params.node.data.term_date === null ||
        params.node.data.term_date === ""
      ) {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #E1E1E1",
        };
      } else if (!localTermDate.isValid()) {
        return {
          display: "flex",
          alignItems: "center",
          backgroundColor: status.error,
        };
      } else if (!validateTermDate(params.node.data.term_date)) {
        return {
          display: "flex",
          alignItems: "center",
          backgroundColor: status.error,
        };
      } else {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #E1E1E1",
        };
      }
    },
    minWidth: 90,
    maxWidth: 150,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Contract Price",
    field: "contract_price",
    type: "rightAligned",
    floatingFilter: false,
    editable: false,
    filter: "agNumberColumnFilter",
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "0.5px solid #E1E1E1",
      justifyContent: "flex-end",
    },
    valueFormatter: myValueFormatter,
    minWidth: 110,
    maxWidth: 150,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Collatoral Code",
    field: "Collatoral_code",
    aggFunc: "sum",
    floatingFilter: false,
    filter: "agTextColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "0.5px solid #E1E1E1",
    },
    width: 140,
    minWidth: 120,
    // maxWidth: 140,
    suppressSizeToFit: false,
    icons: {
      style: { color: "#2D2D2D" },
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Contract Id",
    field: "contract_id",
    floatingFilter: false,
    filter: "agTextColumnFilter",
    editable: false,
    pinned: "right",
    lockPinned: true,
    cellClass: "lock-pinned",
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "0.5px solid #E1E1E1",
    },
    minWidth: 95,
    maxWidth: 180,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" style={{backgroundColor: "#2D2D2D"}}/>`,
    },
  },

  {
    headerName: "Error Code",
    field: "errorCode",
    // hide:true,
    floatingFilter: false,
    // filter: "agNumberColumnFilter",
    filter: "agSetColumnFilter",
    editable: false,
    pinned: "right",
    lockPinned: true,
    cellClass: "lock-pinned",
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "0.5px solid #E1E1E1",
    },
    minWidth: 120,
    maxWidth: 160,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" style={{backgroundColor: "#2D2D2D"}}/>`,
    },
  },
  {
    headerName: "DATA LENGTH",
    field: "dataLength",
    hide: true,
  },
  {
    headerName: "Status",
    field: "status",
    tooltipField: "errorCode",
    tooltipComponentParams: { type: "success" },
    floatingFilter: false,
    editable: false,
    filter: "agSetColumnFilter",
    pinned: "right",
    lockPinned: true,
    cellClass: "lock-pinned",
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
    floatingFilterComponentParams: { suppressFilterButton: true },
    minWidth: 80,
    maxWidth: 100,
    cellStyle: function (params: any) {
      let filteredValues =
        params?.api?.getFilterInstance("status")?.appliedModel?.values;
      if (filteredValues && filteredValues?.length > 0) {
        let index = filteredValues.findIndex(
          (x: string) => x === params.node.data.status
        );
        if (params.node.isSelected() && index === -1) {
          params.node.setSelected(false);
        }
      }
      if (params.node.data.status === "Booked") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #E1E1E1",
          backgroundColor: status.booked
        };
      } else if (params.node.data.status === "Settled") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #E1E1E1",
          backgroundColor: status.settled
        };
      } else if (params.node.data.status === "Error") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #E1E1E1",
          backgroundColor: status.error
        };
      } else if (params.node.data.status === "Failed") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #E1E1E1",
          backgroundColor: status.failed
        };
      } else if (params.node.data.status === "Sent") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #E1E1E1",
          backgroundColor: status.sent
        };
      } else if (params.node.data.status === "Warning") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #E1E1E1",
          backgroundColor: status.warning
        };
      } else if (params.node.data.status === "New") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #E1E1E1",
          backgroundColor: status.new
        };
      } else {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #E1E1E1",
        };
      }
    },
  },
  {
    headerName: "DTC Status",
    field: "dtc_status",
    tooltipField: "errorCode",
    tooltipComponentParams: { type: "success" },
    floatingFilter: false,
    editable: false,
    filter: "agSetColumnFilter",
    pinned: "right",
    lockPinned: true,
    cellClass: "lock-pinned",
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
    floatingFilterComponentParams: { suppressFilterButton: true },
    minWidth: 95,
    maxWidth: 100,
    cellStyle: function (params: any) {
      if (params.node.data.dtc_status === "Booked") {
        return {
          display: "flex",
          alignItems: "center",
          color: "#039100",
          borderRight: "0.5px solid #E1E1E1",
        };
      } else if (params.node.data.dtc_status === "Error") {
        return {
          display: "flex",
          alignItems: "center",
          color: "#E90909",
          borderRight: "0.5px solid #E1E1E1",
        };
      } else if (params.node.data.dtc_status === "Pending") {
        return {
          display: "flex",
          alignItems: "center",
          color: "#0D34FF",
          borderRight: "0.5px solid #E1E1E1",
        };
      } else if (params?.data?.dtc_status?.toLowerCase() === "settled") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #E1E1E1",
          backgroundColor: dtcStatusColors.settled
        };
      } else if (params?.data?.dtc_status?.toLowerCase() === "rad") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #E1E1E1",
          backgroundColor: dtcStatusColors.RAD
        };
      } else if (params?.data?.dtc_status?.toLowerCase() === "approved") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #E1E1E1",
          backgroundColor: dtcStatusColors.approved
        };
      }
      else if (params?.data?.dtc_status?.toLowerCase() === "pended") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #E1E1E1",
          backgroundColor: dtcStatusColors.pended
        };

      } else if (params?.data?.dtc_status?.toLowerCase() === "reversed") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #DFDFDF",
          backgroundColor: dtcStatusColors.reversed
        };
      } else if (params?.data?.dtc_status?.toLowerCase() === "dropped") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #DFDFDF",
          backgroundColor: dtcStatusColors.dropped
        };
      } else if (params?.data?.dtc_status?.toLowerCase() === "non-ccf") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #DFDFDF",
          backgroundColor: dtcStatusColors.nonCcf
        };
      } else if (params?.data?.dtc_status?.toLowerCase() === "canceled") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #DFDFDF",
          backgroundColor: dtcStatusColors.canceled
        };
      } else {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #E1E1E1",
        };
      }
    },
  },
];
